<template>
  <div class="enrollInputTextWrapper">
    <input type="text" maxlength="18" placeholder="답을 기입해주세요."
           v-model="text" v-on:keyup="returnTextLength" v-on:blur="onChangeText">
    <span>{{textLength + '/' + maxLength}}</span>
  </div>
</template>

<script>

export default {
  props: {
    answerCount: Number
  },
  data () {
    return {
      text: '',
      textLength: 0,
      maxLength: 18
    }
  },
  methods: {
    returnTextLength: function (e) {
      this.setTextLength(e.target.value.length)
    },
    setTextLength: function (length) {
      this.textLength = length > 18 ? 18 : length
    },
    onChangeText: function () {
      this.textLength = this.text.length
      this.setTextInfoStore(this.text)
    },
    setTextInfoStore: function (text) {
      this.$store.commit('setEnrollStateValue', {type: 'answerText', adChoiceNumber: this.answerCount, value: {choiceText: text !== '' ? text : null}})
      this.$store.commit('setAdUiStateValue', {type: 'answer' + this.answerCount + 'Text', value: text !== '' ? text : null})
    }
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getRemoveWatchTrigger, value => {
      // 답변 삭제 등으로 답변값이 변경되었을 때 발동
      // 답변 텍스트 변경
      let changedText = this.$store.getters.getEnrollStateArrayValue('answerText', {index: this.answerCount - 1, valueName: 'choiceText'})
      this.text = changedText != null && changedText !== '' ? changedText : ''
      this.onChangeText()
      // 핸드폰 ui 문구 변경
      this.$store.commit('setAdUiStateValue', {type: 'answer' + this.answerCount + 'Text', value: this.text !== '' ? this.text : null})
    })
  },
  created: function () {
    let beforeAnswerTextList = this.$store.getters.getEnrollStateValue('answerText')
    if(beforeAnswerTextList[this.answerCount - 1].choiceText != null) {
      this.text = beforeAnswerTextList[this.answerCount - 1].choiceText
      this.setTextLength(beforeAnswerTextList[this.answerCount - 1].choiceText.length)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type='text']{
  padding: 0 0 10px;
  width: 100%;
  font-size: 13px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  outline: none;
}

.enrollInputTextWrapper{
  margin-top: 20px;
  text-align: right;
  flex: 1;
}

.enrollInputTextWrapper > span{
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/enrollInputTextAnswer.vue